import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import ConsultingBanner from './ConsultingBanner/ConsultingBanner';

const Consulting = () => {
    return (
        <div>
            <Navigation></Navigation>
            <ConsultingBanner></ConsultingBanner>

        </div>
    );
};

export default Consulting;